import React from "react";
import styled from "@emotion/styled";
import loadable from "@loadable/component";
const Guarantee45Days = loadable(() =>
  import(/* webpackChunkName: "GuaranteeButton" */ "./GuaranteeButton")
);
const GiftCenterAd = loadable(() =>
  import(/* webpackChunkName: "GiftCenterAd" */ "./GiftCenterAd")
);

const TabletButtonContainer = styled.div`
  @media (min-width: 768px) {
    display: none;
  }

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;
  margin-bottom: 25px;

  @media (max-width: 450px) {
    margin-bottom: 30px;
    display: block;
  }
`;

const Mobile45DayContainer = styled.div`
  @media (max-width: 450px) {
    display: none;
  }
`;

const BuyTabletButtons = ({ guaranteeText, buttonText }) => {
  return (
    <TabletButtonContainer>
      <Guarantee45Days text={guaranteeText} />
      <Mobile45DayContainer>
        <GiftCenterAd text={buttonText} />
      </Mobile45DayContainer>
    </TabletButtonContainer>
  );
};

export default BuyTabletButtons;
